import React from "react"
import "./about.css"
import Carousel from "./AboutCarousel/Carousel"

const About = () => {
    return (
        <div className="backgr_about">
            <div className="about">
                <div className="titleAbout">
                    <h1>О нас</h1>
                </div>
                <div>
                    <ul className="breadcrumbAbout">
                        <li><a href="/">Главная</a></li>
                        <li>О нас</li>
                    </ul>
                </div>
                <Carousel />
                <div className="about_text">
                    <p>
                        Формула Улыбки - это место, где вы можете получить высококачественные
                        стоматологические услуги от опытных и квалифицированных специалистов.
                        Наша команда состоит из врачей-стоматологов, которые постоянно повышают свою
                        квалификацию и следят за новыми технологиями и оборудованием.
                    </p>
                    <p>
                        Мы предлагаем широкий спектр стоматологических услуг, включая лечение зубов,
                        имплантацию зубов и протезирование. Мы также предоставляем услуги по гигиене
                        полости рта, чтобы помочь вам сохранить здоровье своих зубов и десен.
                    </p>
                    <p>
                        Мы понимаем, что каждый пациент уникален, и поэтому мы всегда слушаем и учитываем
                        их индивидуальные пожелания и потребности. Наша цель - обеспечить нашим пациентам
                        максимальный комфорт и уверенность в их улыбке.
                    </p>
                    <p>
                        Мы используем только самое современное оборудование и высококачественные материалы,
                        чтобы обеспечить нашим пациентам лучшие результаты. Если вы ищете качественную стоматологическую помощь,
                        обращайтесь к нам - мы готовы помочь вам достичь здоровой и красивой улыбки!
                    </p>
                </div>
                <div className="InfAbout">
                    <div className="AboutTitle">
                        <h2>О нас</h2>
                    </div>
                    <div className="Container_about">
                        <p>
                            Клиника «Формула улыбки» открылась в 2013 году,
                            и на сегодняшний день мы оказали
                            квалифицированную стоматологическую помощь
                            большому количеству пациентов.
                        </p>
                        <p>
                            Мы меняем отношение к стоматологу у детей. Доктор становится их другом, которому они доверяют и знают что он всегда будет на их стороне.
                        </p>
                        <p>
                            Мы уже завоевали доверие многих наших пациентов , их родственников и друзей.
                        </p>
                    </div>
                    <div className="aboutBtnContainer">
                        <div className="BtnAbout">
                            <a href="/doctors"><button>Сотрудники</button></a>
                        </div>
                        <div className="BtnAbout">
                            <a href="/vacancy"><button>Наши вакансии</button></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About